import React from "react";
import SubscribeForm from "../components/subscribe.form.component";

class UnSubscribepage extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="col-12 col-sm-12 col-md-7 col-lg-6">
                    <div className="sectionTitle blueTitleBg clearfix d-flex">
                        <h2 className="m-0 float-left mr-auto px-3">Unsubscribe to Our Newsletters</h2>
                    </div>
                    <div className="pageWrap p-3 bg-light shadow-sm subscribePageIn">
                        <SubscribeForm subscribe={false}/>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default UnSubscribepage;